<template>
    <div id="the-pier-wrapper" class="portfolio-page">
        <div id="the-pier">
            <PortfolioHeader 
                :pageName="pageName"
                :disciplines="disciplines" 
                :services="services"
                :pageLink="pageLink"
                :linkName="linkName"
            />
            <section class="">
                <img src="/img/portfolio/the-underground/the-underground-branding.jpg" alt="The Underground - Branding" class="w-100 d-block">
            </section>
            <section class="">
                <img src="/img/portfolio/the-underground/the-underground-clothing.jpg" alt="The Underground - Clothing" class="w-100 d-block">
            </section>
            <ImageAndTextPortfolio 
                :imageAndTextContent="imageAndTextContent"
            />
            <section class="">
                <img src="/img/portfolio/the-underground/the-underground-dance-centre-wall.jpg" alt="The Underground - Dance Wall" class="w-100 d-block">
            </section>
            <section class="conclusion">
                <b-container class="next-project stipple-bg py-5" fluid>
                    <b-container>
                        <div class="">
                            <b-row>
                                <b-col lg="6">
                                    <img src="/img/portfolio/the-underground/the-underground-brand-print-1.jpg" alt="The Underground Print" class="w-100 d-block">
                                </b-col>
                                <b-col lg="6">
                                    <img src="/img/portfolio/the-underground/the-underground-brand-print-2.jpg" alt="The Underground Print" class="w-100 d-block">
                                </b-col>
                            </b-row>
                        </div>
                    </b-container>
                    <NextProject :nextProject="nextProject"/>
                </b-container>
            </section>
            <Transition1063 />
            <AppFooter />
        </div>
    </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

export default {
    head: {
      title: "Guidelines Advertising Inc - The Underground",
      meta: [
        {
            hid: "description",
            content:
            "Guidelines Advertising is a full-service real estate marketing company with over 35 years experience in Toronto, Ontario, Canada."
        },
        { 
            hid: 'keywords', 
            name: 'keywords', 
            content: 'Toronto,Real estate décor consulting Toronto, real estate, marketing, toronto, branding, social media, web development, interior design, print, advertising, content marketing, eglinton'
        }
      ]
    },
    data() {
        return {
            scrollSmoother_theUnderground: null,
            textAnimation_theUnderground: null,
            textAnimation_theUnderground: null,
            disciplines: [
                {
                    name: "CORPORATE"
                }
            ],
            services: [
                {
                    name: "corporate identity creation"
                }
            ],
            pageName: "The Underground Dance Centre",
            pageLink: "",
            linkName: "",
            firstSliderStyles: {
                bgColor: '#d7b140',
                imgOnLeftSide: true,
                heading: "CORPORATE INITIATIVES",
                desc: "The Underground Dance Centre was voted #1 Best Dance Classes in Toronto for good reason. Not only do they have expert instructors teaching a range of dance styles, but they have inclusive corporate initiatives that engage their students and grow the dance community at large. From inviting people across the city to participate in film & TV dance auditions to chairing events that raise awareness about social issues, offering more accessible class packages to inexperienced dancers, and more, they go above and beyond to support their community. 1063 developed combined merchandizing with a strong social media campaign to boost The Underground's brand recognition – helping them reach a far greater audience. This marketing strategy continues to increase their class sales, attract professional teaching talent, and inspire Toronto's dance community at large.",
                subheading: ''
            },
            firstSliderItems: [
                {
                    img: "/img/portfolio/pier/slider/ga-slider-the-pier-apologies.jpg",
                },
                {
                    img: "/img/portfolio/pier/slider/ga-slider-the-pier-apologies.jpg",
                }
            ],
            secondSliderStyles: {
                bgColor: '#000',
                imgOnLeftSide: false,
                heading: "GORILLA MARKETING CAMPAIGN",
                desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                subheading: 'DECO CONCIERGE'
            },
            secondSliderItems: [
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-concierge.jpg",
                    heading: "GORILLA MARKETING CAMPAIGN",
                    desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                    subheading: 'DECO CONCIERGE'
                },
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-concierge.jpg",
                    heading: "CORPORATE INITIATIVES",
                    desc: "The Underground Dance Centre was voted #1 Best Dance Classes in Toronto for good reason. Not only do they have expert instructors teaching a range of dance styles, but they have inclusive corporate initiatives that engage their students and grow the dance community at large. From inviting people across the city to participate in film & TV dance auditions to chairing events that raise awareness about social issues, offering more accessible class packages to inexperienced dancers, and more, they go above and beyond to support their community. 1063 developed combined merchandizing with a strong social media campaign to boost The Underground's brand recognition – helping them reach a far greater audience. This marketing strategy continues to increase their class sales, attract professional teaching talent, and inspire Toronto's dance community at large.",
                    subheading: 'DECO CONCIERGE'
                }
            ],
            imageAndTextContent: {
                imgOnLeftSide: true,
                bgColor: '#96694c',
                bgImageClass: false,
                textColor: "#fff",
                img: "/img/portfolio/the-underground/the-underground-dance-centre.jpg",
                alt: "The Underground",
                heading: "CORPORATE INITIATIVES",
                desc: "The Underground Dance Centre was voted #1 Best Dance Classes in Toronto for good reason. Not only do they have expert instructors teaching a range of dance styles, but they have inclusive corporate initiatives that engage their students and grow the dance community at large. From inviting people across the city to participate in film & TV dance auditions to chairing events that raise awareness about social issues, offering more accessible class packages to inexperienced dancers, and more, they go above and beyond to support their community."
            },
            nextProject: {
                link: "/portfolio/deco-homes",
                name: "DECO Homes"
            }
            
        }
    },
    components: {
        PortfolioHeader: () => import('@/components/PortfolioHeader'),
        FullWidthSlider: () => import('@/components/FullWidthSlider'),
        FullWidthSlider2: () => import('@/components/FullWidthSlider2'),
        ImageAndTextPortfolio: () => import('@/components/ImageAndTextPortfolio'),
        Transition1063: () => import('@/components/Transition1063'),
        NextProject: () => import('@/components/NextProject'),
        AppFooter: () => import('@/components/AppFooter'),
    },
    mounted() {
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);
        ScrollTrigger.refresh();
        setTimeout(() => {
            // CALL THIS FIRST SINCE ITS TECHNICALLY A SCROLLTRIGGER, SO ANY SCROLLTRIGGERS FOLLOWING THIS WOULD BE BUILT OFF OF THE SCROLLSMOOTHER
            this.initscrollSmoother_theUnderground();
            // 
            this.initImgElReveal_theUnderground();
            this.initTextReveal_theUnderground();
        }, 500)
    },
    methods: {
        initscrollSmoother_theUnderground() {
            this.scrollSmoother_theUnderground = ScrollSmoother.create({
                wrapper: '#the-pier-wrapper',
                content: "#the-pier",
                smooth: 3,
                effects: true
            });
            this.scrollSmoother_theUnderground.effects(".plax-img", { speed: "auto" });
        },
        initImgElReveal_theUnderground() {
            let fadeInUpEl = document.querySelectorAll(".fade-in-up-element");

            fadeInUpEl.forEach((container) => {
                let textAnimation_theUnderground = this.textAnimation_theUnderground;
                textAnimation_theUnderground = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.2
                    }
                });

                textAnimation_theUnderground.set(container, { autoAlpha: 1 });
                textAnimation_theUnderground.from(container, 1, {
                    opacity: 0,
                    y: 100,
                    ease: "power2.out"
                });
            });
        },
        initTextReveal_theUnderground() {
            let revealText = document.querySelectorAll(".reveal-text");
            revealText.forEach((container) => {
                let textAnimation_theUnderground = this.textAnimation_theUnderground;
                textAnimation_theUnderground = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.1
                    }
                });

                var splitHide = new SplitText(container, { type: "words", wordsClass: "hide-text" });
                var split = new SplitText(container, {
                    type: "words,lines",
                    wordsClass: "words",
                    linesClass: "lines"
                });
                textAnimation_theUnderground.set(container, { autoAlpha: 1 });
                textAnimation_theUnderground.from(split.words, {
                    delay: 0.5,
                    duration: 0.35,
                    yPercent: 100,
                    stagger: 0.03,
                    ease: 'power2.out'
                });
            })
        }
    },
    beforeDestroy() {
        setTimeout(() => {
            this.scrollSmoother_theUnderground.kill();
        }, 500)
    }
}
</script>

<style lang="scss">
@import '@/assets/styles/variables';

.portfolio-page {
    .cta-section {
        background-image: url('/img/portfolio/pier/the-pier-radio.jpg');
        background-size: cover;
        background-position: center;
        width: 100%;
        height: 100%;
    }

    .pier-background {
        background: url('/img/portfolio/pier/pier-color-theme.jpg') no-repeat center center; 
        background-size: cover;
    }
}


</style>